import React from "react";

// TODO: replace with real profile URLs
const LEETCODE_URL = "https://leetcode.com/u/tgh0/";
const GUITAR_SONG_URL =
  "https://www.songsterr.com/a/wsa/smashing-pumpkins-mayonaise-tab-s17399t4"; // TODO: e.g. a YouTube/Ultimate Guitar link for the current song

const hobbies = [
  {
    id: "leetcode",
    label: "Competitive-ish programming",
    body: (
      <>
        Love the problem solving aspect of Leetcode and it keeps me sharp in the
        AI era -{" "}
        <a href={LEETCODE_URL} target="_blank" rel="noopener noreferrer">
          my profile
        </a>{" "}
        if you're curious.
      </>
    ),
  },
  {
    id: "lifting",
    label: "Lifting",
    body: (
      <>
        Starting strength training back in 2020, been a core part of my life
        since then!
      </>
    ),
  },
  {
    id: "reading",
    label: "Reading",
    body: <>Currently on Book 6 of Red Rising! Fantasy & sci-fi.</>,
  },
  {
    id: "video-games",
    label: "Video Games",
    body: (
      <>
        Gaming is what got me into computers so it's pretty special to me. I
        don't play as much as I used to but here's the accolades:
        <li>Reached highest rank in Rocket League (top 0.2%)</li>
        <li>Second highest rank in CS:GO (top 2.75%)</li>
        <li>Sub 10 minute Minecraft speed run</li>
      </>
    ),
  },
  {
    id: "guitar",
    label: "Guitar",
    body: (
      <>
        Self-taught, still learning. Right now I'm working through{" "}
        <a href={GUITAR_SONG_URL} target="_blank" rel="noopener noreferrer">
          Mayonaise - The Smashing Pumpkins
        </a>
      </>
    ),
  },
];

function More() {
  return (
    <section className="hobbies-section">
      <div className="hobbies-line">
        <h2>Beyond the career stuff</h2>
      </div>

      <ul className="hobbies-list">
        {hobbies.map((hobby) => (
          <li key={hobby.id} className="hobby-entry">
            <span className="hobby-label">{hobby.label}</span>
            <p className="hobby-body">{hobby.body}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default More;
